/**
 * Default Theme
 * Uses Shapermint theme as default
 */

'use client';

import { shapermintTheme } from './shapermint.theme';
import { Theme } from './types';

export const defaultTheme: Theme = shapermintTheme;

